import React, { useState, useEffect } from "react";
import { TextField, Button, FormControl, InputLabel, Select, MenuItem, FormControlLabel, Switch } from "@mui/material";
import { PMDialog } from "../../../utils/PMDialog";
import { useTranslation } from "react-i18next";

export const RemainingAmountSettingsDialog = ({
  open,
  onClose,
  onSave,
  initialSettings = null,
}) => {
  const { t } = useTranslation();
  const [settings, setSettings] = useState({
    enabled: false,
    percentage: 10,
    base: "contract", // "contract" or "completed"
  });

  useEffect(() => {
    if (initialSettings) {
      setSettings({
        enabled: initialSettings.enabled || false,
        percentage: initialSettings.percentage || 10,
        base: initialSettings.base || "contract",
      });
    }
  }, [initialSettings, open]);

  const handleSave = () => {
    onSave(settings);
  };

  return (
    <PMDialog
      open={open}
      onClose={onClose}
      title="Innstillinger for innestående beløp"
      size="md"
      closeOnOutsideClick={false}
    >
      <div className="space-y-4">
        <p className="text-sm text-gray-600 mb-4">
          Konfigurer hvordan innestående beløp skal beregnes. Du kan velge å beregne det som en prosentandel av kontraktsummen eller utført sum.
        </p>

        {/* Enable/Disable */}
        <FormControlLabel
          control={
            <Switch
              checked={settings.enabled}
              onChange={(e) => setSettings({ ...settings, enabled: e.target.checked })}
            />
          }
          label="Bruk prosentvis beregning for innestående beløp"
        />

        {settings.enabled && (
          <>
            {/* Percentage */}
            <TextField
              fullWidth
              label="Prosentandel (%)"
              type="number"
              value={settings.percentage}
              onChange={(e) => {
                const value = parseFloat(e.target.value) || 0;
                setSettings({ ...settings, percentage: Math.max(0, Math.min(100, value)) });
              }}
              inputProps={{ min: 0, max: 100, step: 0.1 }}
              helperText="Angi prosentandel (0-100)"
            />

            {/* Base */}
            <FormControl fullWidth>
              <InputLabel>Beregn basert på</InputLabel>
              <Select
                value={settings.base}
                onChange={(e) => setSettings({ ...settings, base: e.target.value })}
                label="Beregn basert på"
              >
                <MenuItem value="contract">Kontraktsum</MenuItem>
                <MenuItem value="completed">Utført sum</MenuItem>
              </Select>
            </FormControl>

            {/* Preview */}
            <div className="bg-gray-50 p-4 rounded-lg">
              <p className="text-sm font-medium text-gray-700 mb-2">Forhåndsvisning:</p>
              <p className="text-sm text-gray-600">
                Innestående beløp vil beregnes som {settings.percentage}% av{" "}
                {settings.base === "contract" ? "kontraktsummen" : "utført sum"}.
              </p>
            </div>
          </>
        )}

        {/* Actions */}
        <div className="flex justify-end space-x-3 mt-6 pt-4 border-t">
          <Button onClick={onClose}>
            {t("common.cancel")}
          </Button>
          <Button
            onClick={handleSave}
            variant="contained"
            className="bg-blue-600 hover:bg-blue-700"
          >
            Lagre
          </Button>
        </div>
      </div>
    </PMDialog>
  );
};

